import { TextField, Toolbar, Typography } from '@mui/material';
import { getUserFullName } from 'app/utils/appHelpers';
import { useState } from 'react';


function WatchingMeetingDataTableToolbar({ pageTitle, data2, setData }) {

  const [searchText, setSearchText] = useState("");
  const handleChangeSearchText = (text) => {


    if (text !== "") {
      const filterData = data2.filter(
        (item) =>
          item.unit.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
          item.inst === text ||
          item.id === Number(text) ||
          item.meetingNo === Number(text) ||
          getUserFullName(item.user).toLocaleLowerCase().includes(text.toLocaleLowerCase())

      );

      setSearchText(text);
      setData(filterData);

    } else {
      setSearchText(text);
      setData(data2);
    }
  };





  return (
    <Toolbar className="table-header row" sx={{ justifyContent: 'space-between' }}>
      <div className="title">
        <Typography variant="title">{pageTitle}</Typography>
      </div>

      <div>



        <TextField
          id="searchText1xe"
          value={searchText}
          onChange={(e) => handleChangeSearchText(e.target.value)}
          margin="dense"
          label={"Arama Yap"}
          className="mr-4"
          // autoFocus
          style={{ width: "400px", background: 'white' }}
          placeholder={'Bilgi'}
        />
      </div>

    </Toolbar>
  );
}

export default WatchingMeetingDataTableToolbar